import React, { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setEmpAttendanceEmpEmpAction } from "../../../Redux/Slice";
import ReactTable from "../../AppComponent/Table";
import _, { values } from "lodash";
import approved from "../../../Assets/MainComponent/approved.svg";
import declined from "../../../Assets/MainComponent/decline.svg";
import pending from "../../../Assets/MainComponent/pending.svg";
import HeadingComp from "./UdsEmployeeDashboard/CustomHooks/HeadingComp";
import data from "../../../Json/Language/English";
import hindiDatas from "../../../Json/Language/Hinid";
import useLanguageSelector from "./UdsEmployeeDashboard/CustomHooks/useLanguageSelector";
import BackImage from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-20.svg";
import AttendanceRegularizationTeampopu from "./AttendanceRegularizationTeampopu";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export const AttendanceRegularizationEmp = () => {
    const state = useSelector((state) => state)
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const EnglishData = data;
    const HindiData = hindiDatas;
    const hindiApplyLeave = HindiData;

    const [createEditPopup, setCreateEditPopup] = useState(false);
    const [editPayload, setEditPayload] = useState({});
    const [dtpageindex, setdtPageindex] = useState(1);
    const [dtpagesize, setdtPagesize] = useState(10);
    const [sno, setsno] = useState(0);


    const [search, setsearch] = useState("")

    const stateDisplay = useSelector(
        (state) => state.SideBarActive.SidebarActive
    );
    const [selectionMode, setSelectionMode] = useState("single");
    // State for selected IDs
    const [selectedIds, setSelectedIds] = useState([]);

    // Handle radio button change
    const handleSelect = (id) => {
        console.log(id, "a;sd aksjd id");

        if (selectionMode === "single") {
            // In single mode, only one ID should be selected
            setSelectedIds([id]);
        } else {
            // In multi mode, toggle the ID in the selectedIds array
            if (selectedIds.includes(id)) {
                setSelectedIds(selectedIds.filter((selectedId) => selectedId !== id));
            } else {
                setSelectedIds([...selectedIds, id]);
            }
        }
    };

    useEffect(() => {
        if (createEditPopup == false) {
            const payload = {
                page_size: 20,
                page: dtpageindex,
                search: search,
                all: true,
            };
            dispatch(setEmpAttendanceEmpEmpAction(payload));
            setSelectedIds([]);
        }
    }, [dtpageindex, search, createEditPopup]);


    const capitalizeFirstLetter = (Letter) => {
        return Letter.charAt(0).toUpperCase() + Letter.slice(1);
    };
    const handleNext = (next) => {
        setdtPageindex(next + 1);
    };

    const GotoEnteredPage = (gotopage) => {
        setdtPageindex(gotopage)
    }

    const handlePrevious = (previous) => {
        if (previous != 0) {
            setdtPageindex(previous);
        }
    };
    const pagesize = (arg) => {
        setdtPagesize(arg);
    };

    const pageindex = (arg) => {
        setdtPageindex(arg);
    };
    const columns =
        useMemo(
            () => [
                {
                    Header: "S.NO",
                    accessor: "",
                    Cell: (row) => {
                        console.log(row.row);
                        console.log(sno);
                        return <p>{Number(sno + row.row.index + 1)}</p>;
                    },
                },
                {
                    Header: "Employee Name",
                    accessor: "",
                    Cell: (row) => {
                        return (
                            <>
                                {row.row.original.user_id.first_name ? (
                                    <span>{row.row.original.user_id.first_name}</span>
                                ) : (
                                    <span>---</span>
                                )}
                            </>
                        );
                    },
                },
                {
                    Header: "Designation",
                    accessor: "",
                    Cell: (row) => {
                        return (
                            <>
                                {row.row.original.user_id.user_role != null &&
                                    row.row.original.user_id.user_role != undefined ? (
                                    <span>{row.row.original.user_id.user_role.role}</span>
                                ) : (
                                    <span>---</span>
                                )}
                            </>
                        );
                    },
                },

                {
                    Header: "Client",
                    accessor: "",
                    Cell: (row) => {
                        return (
                            <>
                                {row.row.original.client_name != null &&
                                    row.row.original.client_name != undefined ? (
                                    <span>{row.row.original.client_name}</span>
                                ) : (
                                    <span>---</span>
                                )}
                            </>
                        );
                    },
                },

                {
                    Header: "Zone",
                    accessor: "",
                    Cell: (row) => {
                        return (
                            <>
                                {row.row.original.zone_name != null &&
                                    row.row.original.zone_name != undefined ? (
                                    <span>{row.row.original.zone_name}</span>
                                ) : (
                                    <span>---</span>
                                )}
                            </>
                        );
                    },
                },
                {
                    Header: "Select",
                    accessor: "select",
                    Cell: ({ row }) => {
                        const isSelected = selectedIds.includes(row.original.user_id.id);
                        console.log(isSelected, selectedIds, "asdious did selectedIds");

                        return (
                            <span className="SelectTags">
                                <input
                                    type="radio"
                                    className="custom-radioRegurlarization"
                                    name={selectionMode === "single" ? "singleSelect" : `multiSelect-${row.original.user_id.id}`}
                                    checked={isSelected}
                                    onChange={() => {
                                        if (selectionMode === "single") {
                                            setSelectedIds([row.original.user_id.id]);
                                        } else {
                                            if (selectedIds.includes(row.original.user_id.id)) {
                                                setSelectedIds(selectedIds.filter((selectedId) => selectedId !== row.original.user_id.id));
                                            } else {
                                                setSelectedIds([...selectedIds, row.original.user_id.id]);
                                            }
                                        }
                                    }}
                                />
                            </span>
                        );
                    },
                },
                // {
                //     Header: "Select",
                //     accessor: "select",
                //     Cell: ({ row }) => {
                //         const isSelected = selectedIds.includes(row.original.user_id.id);
                // console.log(isSelected ,"isSelected",selectionMode);

                //         return (
                //             <span className="SelectTags">
                //                 <input
                //                     type="radio"
                //                     className="custom-radioRegurlarization"
                //                     name={selectionMode === "single" ? "singleSelect" : `multiSelect-${row.original.user_id.id}`}
                //                     checked={isSelected}
                //                     onChange={() => {
                //                         if (selectionMode === "single") {
                //                             setSelectedIds([row.original.user_id.id]);
                //                         } else {
                //                             setSelectedIds((prevSelectedIds) =>
                //                                 prevSelectedIds.includes(row.original.user_id.id)
                //                                     ? prevSelectedIds.filter((id) => id !== row.original.user_id.id)
                //                                     : [...prevSelectedIds, row.original.user_id.id]
                //                             );
                //                         }
                //                     }}
                //                 />
                //             </span>
                //         );
                //     },
                // }


            ], [sno, selectionMode, selectedIds]
        );


    // -----Search------------------------
    function tochange(e) {
        setdtPageindex(1);
        debouncedSearch(e);

    }
    const debouncedSearch = useMemo(
        () =>
            _.debounce((e) => {
                setsearch(e);
            }, 500),
        []
    );
    React.useEffect(() => {
        return () => {
            debouncedSearch.cancel();
        };
    }, [debouncedSearch]);
    console.log(state.EmpAttendaEmpDataGetList, "EmpAttendaEmpDataGetList");
    const HandleProceed = () => {
        console.log(selectedIds, "asiduasd selectedIds");

    }

    return (
        <>
            <div className={stateDisplay ? "outterContent" : "inner-Content"}>
                <div className="leaveWrapper">

                    <div className="row ButtonPrevious Filters"
                        style={{
                            padding: "4px 4px",
                            margin: "0px",
                            position: "relative",
                            zIndex: "30",

                            marginLeft: "0px",
                            marginRight: "0px",
                        }}>
                        <div className="col-12 leaveHeading text-left">
                            <h3>ATTENDANCE REGULARIZATION</h3>
                        </div>
                        <div className="col">
                            <button
                                className="btn BackImga"
                                onClick={(e) => {
                                    navigate("/teamemp");
                                }}
                            >
                                <img className="PreviousPages" src={BackImage} />
                                <span></span>

                            </button>
                        </div>
                        <div className="col leaveButton AttendanceregularizationEMP">

                            <div className="InnerChoices">
                                <label>
                                    <input
                                        type="radio"
                                        value="single"
                                        className="custom-radioRegurlarization"
                                        checked={selectionMode === "single"}
                                        onChange={() => {
                                            setSelectionMode("single"); setSelectedIds([]);
                                        }}
                                    />
                                    Single
                                </label>
                                <label>
                                    <input
                                        type="radio"
                                        value="multi"
                                        className="custom-radioRegurlarization"

                                        checked={selectionMode === "multi"}
                                        onChange={() => {
                                            setSelectionMode("multi");
                                            setSelectedIds([]);
                                        }}
                                    />
                                    Multi
                                </label>
                            </div>


                            <button
                                className="customButton  ButtonCSS"
                                onClick={() => {
                                    if (selectedIds.length > 0) {
                                        HandleProceed();
                                        setCreateEditPopup(true);
                                    } else {
                                        toast.error(
                                            ` ${"Please select the Employee"} `,
                                            {
                                                position: toast.POSITION.TOP_RIGHT,
                                            }
                                        );
                                    }
                                }}
                                style={{ marginBottom: "20px", background: "#ef4d39", color: "white" }}
                            >
                                {useLanguageSelector(
                                    EnglishData.Attendance_regular.applyButton,
                                    HindiData.Attendance_regular.applyButton
                                )}

                            </button>
                        </div>
                    </div>



                    <div className="col-12 leaveSubHeading">

                        <ReactTable
                            data={state.EmpAttendaEmpDataGetList.EmployeeAttendanceEMpDatas}
                            datacount={state.EmpAttendaEmpDataGetList.Total_Count}
                            columns={columns}
                            pagesize={pagesize}
                            dtpagesize={20}
                            dtpageindex={dtpageindex}
                            pageindex={pageindex}
                            onPrevious={handlePrevious}
                            onNextpage={handleNext}
                            GotoEnteredPage={GotoEnteredPage}
                            MakeCreate={false}
                            Filter={true}
                            NoFilter={true}
                            onChange={tochange}
                            setsno={setsno}
                            sno={sno}
                            id={"spe"}
                            // Search={true}
                        />

                    </div>
                </div>
            </div>


            {createEditPopup == true && (<AttendanceRegularizationTeampopu

                show={createEditPopup}
                setShow={setCreateEditPopup}
                editPayload={editPayload}
                setEditPayload={setEditPayload}
                PageIndex={dtpageindex}
                search={search}
                selectedIds={selectedIds}
                selectionMode={selectionMode}
            />
            )}
        </>


    )
}
